module.exports = __webpack_public_path__ + "static/img/reportForm.f1e01380.jpeg";